"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPG_TICK_MINUTES = exports.EPG_MAX_PIXELS_PER_HOUR = exports.EPG_MIN_PIXELS_PER_HOUR = exports.EPG_PIXELS_PER_HOUR = exports.EPG_PLAYER_NOW_REFRESH_INTERVAL = exports.EPG_NOW_REFRESH_INTERVAL = exports.HOUR_IN_MS = void 0;
exports.HOUR_IN_MS = 60 * 60 * 1000;
exports.EPG_NOW_REFRESH_INTERVAL = 60 * 1000;
exports.EPG_PLAYER_NOW_REFRESH_INTERVAL = 1000;
exports.EPG_PIXELS_PER_HOUR = 240;
exports.EPG_MIN_PIXELS_PER_HOUR = 30;
exports.EPG_MAX_PIXELS_PER_HOUR = 9600;
exports.EPG_TICK_MINUTES = [1, 2, 5, 10, 15, 30, 60, 120, 180, 360];
